import {RATE_MATRIX_CELL_KEY_SEPARATOR} from '../constants/RATE_MATRIX_CELL_KEY_SEPARATOR';

interface ParsedRateMatrixCellKey {
  term: number;
  downPayment: number;
  balloonBracket: number | null;
}

export function parseRateMatrixCellKey(key: string): ParsedRateMatrixCellKey {
  const [termSegment, downPaymentSegment, balloonSegment] = key.split(
    RATE_MATRIX_CELL_KEY_SEPARATOR
  );

  return {
    term: Number(termSegment),
    downPayment: Number(downPaymentSegment),
    balloonBracket: balloonSegment === '' ? null : Number(balloonSegment),
  };
}
